// extracted by mini-css-extract-plugin
export default {"root":"SpotlightOverlay_root--EUX","mask":"SpotlightOverlay_mask--CHW"};